import { createRouter, createWebHistory } from 'vue-router'
import { accountOriginFromLocation } from '../../shared/designer-host.js'

import SuperTurboDesigner from './components/page_layouts/superturbo_designer.vue'
import DataTable from './components/page_layouts/datatable.vue'
import Design from './components/page_layouts/design.vue'
import Automations from './components/page_layouts/automations.vue'
import StepWorkflows from './components/page_layouts/step_workflows.vue'
import AiQuery from './components/page_layouts/ai_query.vue'
import AiBuild from './components/page_layouts/ai_build.vue'
import AppSettings from './components/page_layouts/app_settings.vue'
import Analytics from './components/page_layouts/analytics.vue'
import MenuEditor from './components/page_layouts/menu_editor.vue'

const routes = [
  {
    path: '/:application',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: DataTable
    }]
  },
  {
    path: '/:application/spreadsheets/:spreadsheet?',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: DataTable
    }]
  },
  {
    path: '/:application/design/:page?',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Design
    }]
  },
  {
    path: '/:application/automations/:automation?',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Automations
    }]
  },
  {
    path: '/:application/workflows/:workflow?',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: StepWorkflows
    }]
  },
  {
    path: '/:application/ai-build',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: AiBuild
    }]
  },
  {
    path: '/:application/ai-query',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: AiQuery
    }]
  },
  {
    path: '/:application/settings',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: AppSettings
    }]
  },
  {
    path: '/:application/analytics',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Analytics
    }]
  },
  {
    path: '/:application/menu-editor',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: MenuEditor
    }]
  },
  {
    path: '/:pathMatch(.*)*',
    beforeEnter: () => {
      const account = accountOriginFromLocation(window.location)
      window.location.href = account ? `${account}/#/apps` : VUE_APP_MANAGER_URL
      return false
    },
    component: { template: '<div></div>' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
